define(function (require, exports) {
    'use strict';

    /**
    * Filter for formatting IBAN numbers (groups of 4 numbers)
    */
    exports.iban = function () {
        return function (input) {
            return input.match(/(\d|\D){1,4}/g).join(' ');
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/filters/iban.js